import styled from 'styled-components'

export const LinkContainer = styled.div`
  display: flex !important;
  justify-content: center;
  align-items: center;
  color: #666;

  div {
    display: flex !important;
    align-items: center;
  }

  .link {
    margin-left: 5px;
    cursor: pointer;
  }
`
